import { ServiceRepository } from '@/core/service/domain/ServiceRepository.ts'
import { Service } from '@/core/service/domain/Service.ts'

type GetServicesUseCaseDependencies = { serviceRepository: ServiceRepository }

export class GetServicesUseCase {
  private readonly serviceRepository: ServiceRepository
  constructor({ serviceRepository }: GetServicesUseCaseDependencies) {
    this.serviceRepository = serviceRepository
  }

  execute = (hostId: string): Promise<Service[]> => {
    return this.serviceRepository.getServices(hostId)
  }
}
